export const itemsListColumns = [
    {
        Header: 'Items Id',
        accessor: 'itemsId',
    },
    {
        Header: 'Items Name',
        accessor: 'itemsName',
    },
    {
        Header: 'Category Name',
        accessor: 'categoryName',
    },
    {
        Header: 'Unit',
        accessor: 'unit',
    },
    {
        Header: 'Total Items',
        accessor: 'totalItems',
    },
    {
        Header: 'Items Used',
        accessor: 'itemsUsed',
    },
    {
        Header: 'Laundry Item',
        accessor: 'laundryItem',
    },
    {
        Header: 'Actions',
        accessor: 'actions',
    }
  ];

  export const itemsListTableData = [
    {   
        itemsId:'1101',
        itemsName:'Bed Cover',
        categoryName:'House Keeping',
        unit: 'Per Pieces',
        totalItems: '70',
        itemsUsed: '20',
        laundryItem:'Yes'
    },
    {   
        itemsId:'1102',
        itemsName:'Chairs',
        categoryName:'House Keeping',
        unit: 'Per Pieces',
        totalItems: '60',
        itemsUsed: '10',
        laundryItem:'No'
    },
    {   
        itemsId:'1103',
        itemsName:'Quilt Cover',
        categoryName:'House Keeping',
        unit: 'Per Pieces',
        totalItems: '70',
        itemsUsed: '20',
        laundryItem:'Yes'
    },
    {   
        itemsId:'1104',
        itemsName:'Locker Godrej',
        categoryName:'Facility',
        unit: 'Per Unit',
        totalItems: '70',
        itemsUsed: '20',
        laundryItem:'No'
    },
    {   
        itemsId:'1105',
        itemsName:'Friz',
        categoryName:'Facility',
        unit: 'Per Unit',
        totalItems: '30',
        itemsUsed: '05',
        laundryItem:'No'
    },
    {   
        itemsId:'1106',
        itemsName:'Pillow Cover',
        categoryName:'House Keeping',
        unit: 'Per Pieces',
        totalItems: '30',
        itemsUsed: '20',
        laundryItem:'Yes'
    },
    {   
        itemsId:'1107',
        itemsName:'Pillow',
        categoryName:'House Keeping',
        unit: 'Per Pieces',
        totalItems: '30',
        itemsUsed: '20',
        laundryItem:'Yes'
    },
    {   
        itemsId:'1108',
        itemsName:'Bedsheets',
        categoryName:'House Keeping',
        unit: 'Per Pieces',
        totalItems: '170',
        itemsUsed: '120',
        laundryItem:'Yes'
    },
    {   
        itemsId:'1109',
        itemsName:'Table',
        categoryName:'Facility',
        unit: 'Per Pieces',
        totalItems: '30',
        itemsUsed: '10',
        laundryItem:'No'
    },
    {   
        itemsId:'1110',
        itemsName:'Hair Dryer',
        categoryName:'Facility',
        unit: 'Per Pieces',
        totalItems: '70',
        itemsUsed: '10',
        laundryItem:'No'
    }
]